import { useLocation } from 'react-router';

import { ProcessedSystemLinkItem, SidebarMenuItemProps } from '../../../types';
import { useSidebarContext } from '../SidebarContext';

import { SidebarItem } from './SidebarItem';

export const SidebarLinkItem = ({
  item,
  showIcon = true,
  isInDoubleDrop = false,
}: SidebarMenuItemProps<ProcessedSystemLinkItem['type']>) => {
  const { isActive } = useSidebarContext();
  const { pathname } = useLocation();
  const { title, iconName, href } = item;

  const isActiveItem = isActive(pathname, href);

  return (
    <SidebarItem
      showIcon={showIcon}
      href={href}
      iconName={iconName}
      aqaClass={`aqa_${title}`}
      title={title}
      isActive={isActiveItem}
      isInDoubleDrop={isInDoubleDrop}
    />
  );
};
